import React from 'react'
import styles from './StyledModal.scss'
import Modal from 'react-modal'
// import cx from 'classnames'
import { Icon } from 'common/Icon'

const defaultOverlay = {
  zIndex: 1002,
  backgroundColor: 'rgba(255, 255, 255, 0.85)'
}
const defaultContent = {
  width: '80vw',
  top: '10vh',
  left: 40,
  right: 40,
  bottom: 'auto',
  margin: '0 auto',
  boxShadow: '2px 2px 8px rgba(0, 0, 0, 0.1)',
  padding: '0 0'
}

export const StyledModal = ({ children, showModal, maxWidth = 800, maxHeight = 800, onRequestClose, ...props }) => {
  const contentStyle = { ...defaultContent, maxWidth, maxHeight }

  return (
    <Modal style={{ overlay: defaultOverlay, content: contentStyle }}
      isOpen={showModal}
      contentLabel='StyledModal'
      onRequestClose={onRequestClose}
      {...props}>
      <Icon i='ios-close' size={18} onClick={onRequestClose} className={styles.closeButton} />
      {children}
    </Modal>
  )
}
